import VDivider from './VDivider'

VDivider.install = function install (Vue) {
  Vue.component(VDivider.name, VDivider)
}

export default VDivider



// WEBPACK FOOTER //
// ./src/components/VDivider/index.js